var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Person") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Person",
    stroke: "#B5B5B5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,2.65738525 C6.84021635,2.65738525 2.65738525,6.84021635 2.65738525,12 C2.65738525,14.4778155 3.64169362,16.8541461 5.39377376,18.6062262 C7.14585389,20.3583064 9.52218451,21.3426147 12,21.3426147 C14.4778155,21.3426147 16.8541461,20.3583064 18.6062262,18.6062262 C20.3583064,16.8541461 21.3426147,14.4778155 21.3426147,12 C21.3426147,6.83353405 17.1384381,2.65738525 12,2.65738525 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7259171,12.8010762 C13.5001811,12.8010762 14.921904,11.3687578 14.921904,9.59449385 C14.921904,7.82022987 13.5001811,6.38791145 11.7259171,6.38791145 C9.95165316,6.38791145 8.51933474,7.82022987 8.51933474,9.59449385 C8.51933474,11.3687578 9.95165316,12.8010762 11.7259171,12.8010762 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3817985,18.0909993 C18.3817985,15.7948084 15.4235442,13.9411516 11.731739,13.9411516 C8.03993385,13.9411516 5.05963294,15.7948084 5.05963294,18.0909993",
    id: "Stroke-3-Copy"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.4ab93b01.svg";
export { ForwardRef as ReactComponent };